import { Phone } from "lucide-react";
import { CALL_FORWARD_STATIC_PHONE, formatPhoneNumber } from "@/lib/constants";
import { cn } from "@/lib/utils";

interface CallButtonProps {
  className?: string;
  iconClassName?: string;
  showCallPrefix?: boolean;
  phoneNumber?: string;
}

export default function CallButton({
  className,
  iconClassName,
  showCallPrefix = true,
  phoneNumber = CALL_FORWARD_STATIC_PHONE,
}: CallButtonProps) {
  const isDynamicNumber = phoneNumber !== CALL_FORWARD_STATIC_PHONE;

  return (
    <a
      href={`tel:${phoneNumber}`}
      className={cn(
        "inline-flex items-center justify-center gap-2 bg-[#FFB703] hover:bg-[#FFB703]/90 text-[#090739] font-semibold rounded-md w-full sm:w-auto",
        className,
      )}
      suppressHydrationWarning={isDynamicNumber || undefined}
    >
      <Phone className={cn("shrink-0", iconClassName)} />
      <span
        className="tabular-nums"
        suppressHydrationWarning={isDynamicNumber || undefined}
      >
        {showCallPrefix
          ? `Call ${formatPhoneNumber(phoneNumber)}`
          : formatPhoneNumber(phoneNumber)}
      </span>
    </a>
  );
}
